var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.435,
    height: 25.382,
    viewBox: "0 0 37.435 25.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31888",
    x: 0,
    y: 0,
    width: 37.435,
    height: 25.382,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IR-Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31888-2",
    "data-name": "Rectangle 31888",
    width: 34.435,
    height: 22.382,
    transform: "translate(1.5 0.5)",
    fill: "#169b62"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31889",
    "data-name": "Rectangle 31889",
    width: 11.479,
    height: 22.382,
    transform: "translate(22.956)",
    fill: "#ff883e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31887",
    "data-name": "Rectangle 31887",
    width: 11.477,
    height: 22.382,
    transform: "translate(11.479)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrFlag);
export default __webpack_public_path__ + "static/media/IR-Flag.ef8a092f8e309c95bdbe6504b0bee3e0.svg";
export { ForwardRef as ReactComponent };